// extracted by mini-css-extract-plugin
export default {"modalButton":"styles_modalButton__hZ-7V","redOverlay":"styles_redOverlay__v9Jif"};